// extracted by mini-css-extract-plugin
export var backdropBlur = "_ce-0";
export var contentCard = "_ce-5";
export var frame = "_ce-2";
export var image = "_ce-4";
export var imagePane = "_ce-3";
export var modal = "_ce-1";